export default "__VITE_ASSET__B1FaGYF0__"